import { render, staticRenderFns } from "./InternalSignersDialog.vue?vue&type=template&id=197e5a28&scoped=true"
import script from "./InternalSignersDialog.vue?vue&type=script&lang=js"
export * from "./InternalSignersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197e5a28",
  null
  
)

export default component.exports